import { lazy, Suspense, useEffect, useState } from 'react';
import { api } from './api';
import { Login } from './Login';
import { BusyLayer } from './Busy';
import { BottomNav, Label, Panel, ThemeSwitch } from './ui';
import { Now } from './screens/Now';
import { Settings } from './screens/Settings';
import { Thread, Threads } from './screens/Thread';
import { Lenses } from './screens/Lenses';
import { Ask } from './screens/Ask';
import { Decisions } from './screens/Decisions';
// the 3D graph (three.js) is only downloaded when it is opened
const Graph = lazy(() => import('./screens/Graph').then((m) => ({ default: m.Graph })));


function useRoute() {
  const [r, setR] = useState(location.hash || '#/most');
  useEffect(() => { const f = () => setR(location.hash || '#/most'); addEventListener('hashchange', f); return () => removeEventListener('hashchange', f); }, []);
  return r;
}
function useWide() {
  const q = '(min-width: 1100px)';
  const [w, setW] = useState(() => matchMedia(q).matches);
  useEffect(() => { const m = matchMedia(q); const f = () => setW(m.matches); m.addEventListener('change', f); return () => m.removeEventListener('change', f); }, []);
  return w;
}

function Soon({ title, c, text }: { title: string; c: string; text: string }) {
  return <Panel c={c}><Label c={c}>{title}</Label><p className="muted">{text}</p></Panel>;
}

export function App() {
  const [state, setState] = useState<{ hasPasskeys: boolean; loggedIn: boolean; method: string | null } | null>(null);
  const route = useRoute();
  const wide = useWide();
  const refresh = () => api('/api/auth/state').then(setState).catch(() => setState({ hasPasskeys: true, loggedIn: false, method: null }));
  useEffect(() => { refresh(); }, []);

  if (!state) return <main className="login"><div className="j-core" style={{ width: 120 }}><img src="/img/hud-orb.webp" alt="" /></div></main>;
  if (!state.loggedIn || state.method !== 'passkey') return <Login hasPasskeys={state.hasPasskeys} recoveryOnly={state.method === 'recovery'} onDone={refresh} />;

  const graph = <Suspense fallback={<p className="muted">Életgráf betöltése…</p>}><Graph key={route.includes('ask=') ? route : 'graf'} /></Suspense>;
  const screen = (r: string) => {
    if (r.startsWith('#/beallitasok')) return <Settings onLogout={refresh} />;
    const m = /^#\/szal\/([^/?]+)/.exec(r);
    if (m) return <Thread id={decodeURIComponent(m[1]!)} />;
    if (r.startsWith('#/szalak')) return <Threads />;
    const lens = /^#\/lencse\/?([a-z]*)/.exec(r);
    if (lens) return <Lenses tab={lens[1] || 'penz'} />;
    if (r.startsWith('#/graf')) return graph;
    if (r.startsWith('#/kerdezz')) return <Ask />;
    if (r.startsWith('#/dontesek')) return <Decisions />;
    return <Now />;
  };

  return (
    <div className={`shell ${wide ? 'wide' : ''}`}>
      <BusyLayer />
      <header className="top">
        <a href="#/most" className="brand">JARVIS</a>
        <div className="j-row"><ThemeSwitch /><a className="j-btn" href="#/beallitasok" aria-label="Beállítások">⚙</a></div>
      </header>
      {wide ? (
        <div className="cols">
          <section className="col col-now"><Now compact /></section>
          <section className="col col-main">{route.startsWith('#/most') || route.startsWith('#/graf') ? graph : screen(route)}</section>
          <section className="col col-ask"><Ask compact /></section>
        </div>
      ) : (
        <main className="col-phone">{screen(route)}</main>
      )}
      {!wide && <BottomNav route={route} />}
    </div>
  );
}
